export default __webpack_public_path__ + "static/onboarding1-1e87c9bd71fe76de4dfd9d762a91a008.webp";